import React, { Fragment, createRef, useState } from 'react';
import { useStore, useSelector } from 'react-redux';

function ScrollToAnchor(props) {
  let backgroundGradient;
  let leftLink = '';
  let rightLink = '';

  if (props.type == 'blue') {
	backgroundGradient = 'blue-bg-gradient';
  }
  else {
	backgroundGradient = 'white-bg';
  }
 
  const consumerFormActive = useSelector((state) => state.consumerFormActive)

  {/* Before either yes or no is clicked there is no white form - hense this component. */}
  if (consumerFormActive === 'yes' || consumerFormActive === 'no') {
	  backgroundGradient = 'white-bg';
  }

  return (
	  <Fragment>
		<div className={'container-fluid ' + backgroundGradient}>
			<div className="container">
				<div className={'row ' + backgroundGradient}>
					<div className="col text-center">
						<div className="scroll-to-a blue">
						<a href="#"><i className="scroll-to-arrow up blue"></i></a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="container-fluid blue-bg">
			<div className="container">
				<div className="row text-center blue-bg">
					<div className="col pt-2 pb-2 pl-2 text-left">
						<span className="copy-white">{leftLink}</span>
					</div>
					<div className="col pt-2 pb-2">
						<span className="copy-white">BACK TO TOP</span>
					</div>
					<div className="col pt-2 pb-2 pr-2 text-right">
						<span className="copy-white">{rightLink}</span>
					</div>
				</div>
			</div>
		</div>
	</Fragment>
  	)
  }	

  export default ScrollToAnchor;